import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../../../components/fonts/font-props';

import CustomCollapsible from '../../ui/custom-collapsible/custom-collapsible';
import { PolicyResult } from '../../order-eligibility-display.service';

import PolicyResultItem from './policy-result-item';

interface PolicyResultsSectionProps {
    policyResults: PolicyResult[];
}

const PolicyResultsSection: React.FC<PolicyResultsSectionProps> = ({ policyResults }) => {
    if (policyResults.length === 0) {
        return null;
    }

    return (
        <CustomCollapsible
            title={
                <FontBody2 color={FONT_COLOR.PRIMARY3}>
                    View All Policy Results
                </FontBody2>
            }
            isExpanded={false}
            level="secondary"
        >
            <div className="item-policy-details">
                {policyResults.map((policyResult: PolicyResult, policyIndex: number) => (
                    <PolicyResultItem 
                        key={policyIndex} 
                        policyResult={policyResult} 
                    />
                ))}
            </div>
        </CustomCollapsible>
    );
};

export default PolicyResultsSection;
